import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { CloseByStations } from "../components/close-by-stations";
import { Layout } from "../components/layout";
import { SavedStationTransports } from "../components/saved-station-transports";
import { SearchDeparture } from "../components/search-station";
import { Station } from "../components/station";
import { getStations } from "../services/sl";
import { Station as StationType } from "../types/station";
export function Departures() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [stations, setStations] = useState<StationType[]>([]);
  const [station, setStation] = useState<StationType | null>(null);
  const [loading, setLoading] = useState(false);
  const stationId = searchParams.get("station");

  useEffect(() => {
    (async () => {
      setLoading(true);
      const stations = await getStations();
      setStations(stations);
      setLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (!stationId) {
      return;
    }

    const station = stations.find((s) => s.id === Number(stationId));
    if (station) {
      setStation(station);
    }
  }, [stationId, stations]);

  return (
    <Layout>
      {!loading && (
        <div className="p-4">
          <div className="flex flex-col sm:flex-row gap-2 justify-between mb-4">
            <div className="flex items-center gap-2">
              <SearchDeparture
                value={station}
                onSelect={(station) => {
                  navigate(`/departures?station=${station.id}`);
                }}
              />
              <CloseByStations />
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              <SavedStationTransports stations={stations} />
            </div>
          </div>
          {station && <Station station={station} />}
        </div>
      )}
    </Layout>
  );
}
